import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { classNames } from '../../utils/classNames';

interface IInput {
    label?: string;
    register?: UseFormRegisterReturn;
    placeholder?: string;
    error?: string;
    type?: string;
    containerStyle?: string;
    inputValue?: string | number;
    showValue?: boolean;
    inputUniqueName?: string;
    inputStyle?: string;
    hideInputSpace?: boolean;
    icon?: string;
    index?: any;
    disabled?: boolean;
    dataQa?: string;
    parent?: any;
    labelStyle?: string;
    onHandleKeyDown?: (e: any, type?: string, index?: any) => void;
    onChangeInput?: (value: string | null | undefined, type: string, index?: any, parent?: any) => void;
}

const Input = ({
    register,
    placeholder,
    type,
    error,
    label,
    containerStyle,
    inputValue,
    showValue,
    labelStyle,
    inputUniqueName,
    inputStyle,
    hideInputSpace,
    icon,
    index,
    disabled,
    dataQa,
    parent,
    onChangeInput,
    onHandleKeyDown,
}: IInput) => {
    return (
        <div className={containerStyle || 'mb-3'}>
            {!!label && <label className={`block text-primary-light dark:text-white font-normal text-base mb-2 ${labelStyle}`}>{label}</label>}
            {icon && <img src={icon} className={'absolute w-[18px] object-contain left-2 top-[27%]'} />}
            <input
                {...register}
                disabled={disabled || false}
                type={type}
                {...showValue && ({
                    value: inputValue || '',
                    onChange: (e) => onChangeInput?.(e?.target?.value, inputUniqueName || '', index, parent),
                    onKeyDown: (e) => onHandleKeyDown?.(e, inputUniqueName || '', index)
                })}
                data-qa={dataQa || ''}
                placeholder={placeholder}
                autoComplete='off'
                className={classNames('border border-borderColor rounded w-full px-3 py-2 dark:bg-[#333] dark:text-white', error ? 'border-red-500' : '', icon ? 'pl-8' : '', inputStyle || '')}
            />
            {error ? <span className='block text-xs text-red-500'>{error}</span> : !hideInputSpace && <span className='block h-2 mt-2' />}
        </div>

    )
}

export default Input;